// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_df-6";
export var emphasizeQuantity = "_df-3";
export var flatBottomCorners = "_df-5";
export var productImage = "_df-0";
export var quantityContainer = "_df-2";
export var tooltip = "_df-1";
export var wrapAndEllipsesOverflow = "_df-4";